import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { Guid } from '@web/utils';
import { AdminOrderRefundDataItemResponse } from './admin-order-refund-data-item.response';
import { AdminOrderRefundDataShipmentResponse } from './admin-order-refund-data-shipment.response';

@jsonObject
export class AdminOrderRefundDataResponse {
  @jsonMember(String)
  public readonly orderId!: Guid;

  @jsonMember(String)
  public readonly orderNumber!: string;

  @jsonArrayMember(AdminOrderRefundDataItemResponse)
  public readonly items!: AdminOrderRefundDataItemResponse[];

  @jsonArrayMember(AdminOrderRefundDataShipmentResponse)
  public readonly shipments!: AdminOrderRefundDataShipmentResponse[];
}
